// This file is auto-generated. Do not edit manually.

import { DiagnosticLevel } from './DiagnosticLevel';

export const scoringQuestionsByGroup: Record<string, string[]> = {
  'Etoile1': [
    'bainLargeurPorte90',
    'bainPrisesBasses',
    'bainPrisesHautes',
    'chambreLargeurPorte90',
    'chambrePlacardAdapte',
    'chambrePrisesBasses',
    'chambrePrisesHautes',
    'chambresLargeurPorte90',
    'chambresPrisesBasses',
    'chambresPrisesHautes',
    'chambresRetournement',
    'communAscenseurNorme',
    'communBoiteManoeuvre',
    'communHallEclairage90',
    'communHallEclairageAuto',
    'cuisineEspace',
    'cuisinePrisesCredence',
    'cuisineProfondeur',
    'cuisineSiphon',
    'dispositifHanteur90',
    'dispositifPrisesBasses',
    'dispositifPrisesHautes',
    'doucheCloisons',
    'doucheParois',
    'entreeLargeur',
    'generalLargeurEgal120',
    'generalLargeurPorte90',
    'generalPlacardAdapte',
    'generalPrisesBasses',
    'generalPrisesHautes',
    'jardinRampe',
    'lavaboHauteur',
    'statioProxi',
    'statioSousSol',
    'terrasseRampe',
    'wcCloison',
  ],
  'Etoile1Obligatoire': [
    'doucheCloisons',
    'doucheReceveurSansRessaut',
  ],
  'Etoile2': [
    'communAscenseurNormeType3',
    'communPorteFourreau',
    'dispositifManoeuvreSecours',
    'doucheItalienne',
    'doucheItalienneOk',
    'entreeAuto',
    'entreeEclairage',
    'generalLargeurSup120',
    'jardinAcces',
    'lavaboHauteurReglable',
    'statioDedie',
    'terrasseAcces',
    'terrasseFourreau',
    'terrasseRessaut',
    'wcSuspendu',
  ],
  'Etoile3': [
    'chemExtPortillonAuto',
    'chemExtPortillonTele',
    'communAscenseurHori',
    'communPorteAuto',
    'communPorteTele',
    'statioSousSolMotorise',
    'statioSurface',
    'statioSurfaceMotorise',
  ],
  'Etoile3Obligatoire': [
    'communPorteAuto',
  ],
  'Senior': [
    'dispositifFourreauVolets',
    'dispositifVoletElec',
    'doucheBarreAppui',
    'doucheReceveurEncastre',
    'doucheSiege',
    'wcBarreAppui',
    'wcHauteur',
  ],
};

export const diagnosticLevelRequirements: Record<DiagnosticLevel, Record<string, number>> = {
  [DiagnosticLevel.Accessible]: { },
  [DiagnosticLevel.Senior]: { 'Senior': 5 },
  [DiagnosticLevel.OneEtoile]: { 'Etoile1': 24,  'Etoile1Obligatoire': 2 },
  [DiagnosticLevel.TwoEtoiles]: { 'Etoile2': 12 },
  [DiagnosticLevel.ThreeEtoiles]: { 'Etoile3': 3,  'Etoile3Obligatoire': 1 },
};
